/**
 * Centralized theme colors and styles
 */

export const theme = {
  colors: {
    // Primary
    primary: '#2196F3',
    primaryDark: '#1976D2',

    // Text
    textPrimary: '#333',
    textSecondary: '#666',
    textLight: '#999',
    textWhite: '#fff',

    // Status
    error: '#f44336',
    warning: '#ff9800',
    success: '#4CAF50',
    info: '#2196F3',

    // Backgrounds
    bgLight: '#e0e0e0',
    bgWhite: '#fff',

    // Borders
    border: '#ccc',
  },
};
